module.exports = __webpack_public_path__ + "media/images/front/products/vscan/index-banner-2eb9e6f92d5c93837b3e9329f4a01569.jpg";